// Opens the global Help & Guide panel from anywhere.
// Layout listens for this event and shows the guide.
export function openHelpGuide() {
  window.dispatchEvent(new Event("bloomtrack:open-help"));
}
